// API-related functions for AIChatBox
import { callApiWithAuthorization } from '../../API/CallApi';
import { getLoggedInUserUsingAccessToken } from "../../API/User/User";

export async function sendMessage({ threadId, prompt, projectId, subscriptionId, organizationId, previousResponseId }) {
    const request = await callApiWithAuthorization('/api/v0/prompt-ai', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            prompt,
            projectId,
            subscriptionId,
            organizationId,
            previousResponseId
        })
    });
    const response = await request.json();
    return response;
}

export async function addContextMessageToAssistant(threadId, context) {
    const request = await callApiWithAuthorization('/api/v0/ai/add-message-to-thread', {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            threadId,
            message: context,
            role: "user"
        })
    });
    const response = await request.json();
    return response;
}

export async function getCurrentUserId(msalContext) {
    if (msalContext.accounts.length === 0) {
        const user = await getLoggedInUserUsingAccessToken();
        return user.azureId;
    }
    if (msalContext.accounts.length > 0)
        return msalContext.accounts[0].localAccountId;
    throw new Error("User is not logged in to designer");
}
